/**
 * Navigation listener for the visual runtime (contract §3.4).
 *
 * Independent of the tracker's own SPA listener (which is skipped in abMode,
 * datalayer mode and iframe mode): wraps history.pushState/replaceState and
 * listens to popstate/hashchange, firing the callback once per distinct URL.
 */
const FLAG = '__b2mVisualNav';

export function installNavigationListener(win, onChange) {
  if (!win || !win.history) return () => {};
  let last = win.location.href;
  const check = () => {
    const href = win.location.href;
    if (href === last) return;
    last = href;
    try { onChange(href); } catch (e) { /* ignore */ }
  };
  const history = win.history;
  const originalPush = history.pushState;
  const originalReplace = history.replaceState;
  const wrap = (original) => function wrapped(...args) {
    const result = original.apply(this, args);
    // Let the router finish its synchronous work before we read the URL.
    setTimeout(check, 0);
    return result;
  };
  let wrappedPush = null;
  let wrappedReplace = null;
  if (!history[FLAG]) {
    wrappedPush = wrap(originalPush);
    wrappedReplace = wrap(originalReplace);
    history.pushState = wrappedPush;
    history.replaceState = wrappedReplace;
    history[FLAG] = true;
  }
  win.addEventListener('popstate', check);
  win.addEventListener('hashchange', check);
  return () => {
    win.removeEventListener('popstate', check);
    win.removeEventListener('hashchange', check);
    if (wrappedPush && history.pushState === wrappedPush) history.pushState = originalPush;
    if (wrappedReplace && history.replaceState === wrappedReplace) history.replaceState = originalReplace;
    if (wrappedPush) delete history[FLAG];
  };
}
